export default "__VITE_ASSET__BuRHddAv__"